import { SxProps } from "@mui/material/styles";
import { ChevronsLeft } from "lucide-react";
import { useSidebarContextSelector } from "@/components/NotePage/hooks/SidebarContext";
import CircularButton from "@/components/CircularButton";
import { iconSizes } from "@/utils/iconProps";
import { themeColors } from "@/utils/themeColors";

const FullScreenButton = ({ onClick, sx, className }: { onClick?: () => void; sx?: SxProps; className?: string }) => {
    const isNoteSidebarCollapse = useSidebarContextSelector(s => s.isNoteSidebarCollapse);

    return (
        <CircularButton
            className={className}
            tooltip={isNoteSidebarCollapse ? "open sidebar" : "close sidebar"}
            sx={{
                position: "sticky",
                top: "3rem",
                alignSelf: "flex-start",
                backgroundColor: themeColors.neutralWhite,
                border: `1px solid ${themeColors.neutral1}`,
                "&:hover": {
                    backgroundColor: themeColors.neutralBlack,
                    "& svg": {
                        stroke: themeColors.neutralWhite,
                    },
                },
                ...sx,
            }}
            radius="4rem"
            onClick={onClick}>
            <ChevronsLeft
                size={iconSizes.MD}
                color={themeColors.neutralBlack}
                style={{ transform: `rotate(${isNoteSidebarCollapse ? 180 : 0}deg)` }}
            />
        </CircularButton>
    );
};

export default FullScreenButton;
